import * as React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { BuilderComponent } from '@builder.io/react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '../components/Link/Link';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import '../builder-settings';

const useStyles = makeStyles(them => ({
  root: {
    
  },
  header: {},
  footer: {},
  content: {
    paddingTop: '125px' // Height of fixed header
  }
}));

const query = graphql`
  query {
    allBuilderModels {
      oneSiteSettings {
        content
      }
      oneNavigation {
        content
      }
      oneFooter {
        content
      }
    }
  }
`;

function PageLayout({ children }) {
  const classes = useStyles();
  return (
    <StaticQuery query={query}>
      {data => {
        const models = data?.allBuilderModels;
        
        // Builder.io content is already parsed as objects
        const navigation = models?.oneNavigation?.content?.data?.links || [];
        const siteName = models?.oneSiteSettings?.content?.data?.siteName || '';
        const footer = models?.oneFooter?.content || null;
        
        return (
          <div className={classes.root}>
            <Header links={ navigation } />
            <div className={classes.content}>{children}</div>
            <div className={classes.footer}>
              <BuilderComponent
                renderLink={Link}
                name="footer"
                content={footer}
              />
              <Footer links={ navigation } siteName={ siteName }/>
            </div>
          </div>
        );
      }}
    </StaticQuery>
  );
}

export default PageLayout;
